import _extends from "@babel/runtime/helpers/extends";
import { Checkbox } from '@atlaskit/checkbox';
import { Field } from '@atlaskit/form';
import React from 'react';
import LabelComponent from '../LabelComponent/LabelComponent';
const CheckboxInput = _ref => {
  let {
    options,
    onChange,
    value,
    isDisabled,
    fieldName
  } = _ref;
  const handleChange = event => {
    onChange(event.target.checked);
  };
  return /*#__PURE__*/React.createElement(Field, {
    name: fieldName,
    defaultValue: value === null || value === void 0 ? void 0 : value.toString()
  }, _ref2 => {
    let {
      fieldProps
    } = _ref2;
    return options.map(_ref3 => {
      let {
        label
      } = _ref3;
      return /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
        type: "radio",
        onChange: handleChange,
        label: /*#__PURE__*/React.createElement(LabelComponent, {
          label: label
        }),
        key: label.text,
        isChecked: value,
        isDisabled: isDisabled,
        testId: fieldName,
        role: "checkbox"
      }));
    });
  });
};
export default CheckboxInput;